import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CheckboxModule } from 'primeng/checkbox';


import { ReactiveFormsModule } from '@angular/forms';
import { injectNgControl } from '@core/helpers';
import { NoopValueAccesorDirective } from '@shared/directives';
import { NgClass } from '@angular/common';

@Component({
  selector: 'prime-checkbox',
  standalone: true,
  hostDirectives: [NoopValueAccesorDirective],
  imports: [
    NgClass,
    ReactiveFormsModule,
    CheckboxModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './prime-checkbox.component.html',
  styleUrl: './prime-checkbox.component.scss'
})
export class PrimeCheckboxComponent {
  onChange = output<void>();

  checkboxId = input<string>();
  classes = input<string>();


  ngControl = injectNgControl();


  handleChange() {
    this.onChange.emit();
  }
}
